import React, { useState } from 'react'
import { Flex } from 'ui/acro'
import styled from 'styled-components'
import { Button } from 'ui/bend'
import EventCarouselCard from './Cards/EventCarouselCard'
import useEventAddToCalendar from 'hooks/useEventAddToCalendar'

const Container = styled(Flex)({
  flexDirection: 'column'
})
const CardWrapper = styled('div')({
  transition: 'all 0.3s ease'
})

const MOBILE_LIMIT = 2

const MyEventsMobile = ({
  events,
  section,
  totalCount,
  loadNextPageData,
  currentPage
}) => {
  const [expanded, setExpanded] = useState(false)
  const [cancelledIds, setCancelledIds] = useState([])
  const { AddToCalendarDialog, handleAddToCalendarClick } =
    useEventAddToCalendar()
  const activeEvents = events.filter((e) => !cancelledIds.includes(e?.id))
  const visibleItems = expanded
    ? activeEvents
    : activeEvents.slice(0, MOBILE_LIMIT)
  const gaLocation = section === 'past' ? 'past' : 'my_events'

  const handleEventCancelled = (id) =>
    setCancelledIds((prev) => (prev.includes(id) ? prev : [...prev, id]))

  const handleViewMore = () => {
    setExpanded(true)
    if (
      parseInt(totalCount) > events.length &&
      visibleItems.length === events.length
    ) {
      loadNextPageData({ section: section, pageNumber: currentPage + 1 })
    }

    if (parseInt(totalCount) === visibleItems.length) {
      setExpanded(false)
    }
  }
  return (
    <Container>
      {visibleItems.map((item, index) => (
        <CardWrapper key={item?.id}>
          <EventCarouselCard
            {...item}
            location={gaLocation}
            position={index + 1}
            handleEventAddToCalendarClick={handleAddToCalendarClick}
            onEventCancelled={handleEventCancelled}
          />
        </CardWrapper>
      ))}

      {parseInt(totalCount) > MOBILE_LIMIT && (
        <Button
          onClick={() => handleViewMore()}
          height='24px'
          width='100%'
          mt='24px'
          variant='ouline'
          style={{
            fontSize: '16px',
            fontWeight: 500,
            color: '#000',
            cursor: 'pointer'
          }}
        >
          {parseInt(totalCount) === visibleItems.length
            ? 'View Less'
            : 'Show All'}
        </Button>
      )}
      {AddToCalendarDialog}
    </Container>
  )
}
export default MyEventsMobile
